import React from "react";
import moment from "moment";

import { CampoEstatico, Card, TipoCampoEstatico } from "@intechprev/componentes-web";
import { ContrachequeEntidade } from "../../../../entidades";

interface IProps {
  ultimaFolha: { Resumo: ContrachequeEntidade, Abono: ContrachequeEntidade }
}

export const UltimaFolha: React.FC<IProps> = ({
  ultimaFolha
}) => {

  if (ultimaFolha && ultimaFolha.Resumo && ultimaFolha.Resumo.Proventos.length > 0) {
    return (
      <Card titulo={"Total do Benefício em"} textoBadge={moment(ultimaFolha.Resumo.Resumo.Competencia, "DD/MM/YYYY").format("MM/YYYY")} tipoBadge={Card.TipoBadge.success}>
        {/* <h6 className={"text-right text-secondary mb-4"}></h6> */}
        <br />
        <h2 className={"text-center mb-5"}>Valor Líquido: <CampoEstatico valor={ultimaFolha.Resumo.Resumo.Liquido} tipo={TipoCampoEstatico.dinheiro} /></h2>
        <hr />
        <h3 className={"text-center mb-5"}>{"Valor do Abono: "}<CampoEstatico valor={ultimaFolha.Abono.Resumo.Liquido} tipo={TipoCampoEstatico.dinheiro} /></h3>
      </Card>
    )
  }

  return (
    null
  );
}